import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* refusalEdit(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/refusalEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool) {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:res.data.comment} });
      yield delay(500);

      yield put({
        type: "SEARCH_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "MAIL_GROUP_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "COMMUNITY_POST_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "COMMUNITY_QA_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "COMMUNITY_KEYWORD_USER_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "FOOTPRINT_PARTNER_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "TIMELINE_FOOTPRINT_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['setting'],
    		},
      });
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment:res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('REFUSAL_EDIT', refusalEdit),
];

export default saga;
